import { render, staticRenderFns } from "./PrivateContact.vue?vue&type=template&id=6a516fa8&"
import script from "./PrivateContact.vue?vue&type=script&lang=js&"
export * from "./PrivateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports